/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.13.0
 */

import { useCallback } from 'react';

import { useParams } from 'react-router-dom';

import { icons } from '../../../../../assets';
import { EOnboardingComponentsId } from '../../../../../modules/onboarding/types/onboardingTypes';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import { ExternalRoutePath, openExternalRoute } from '../../../../../routes/constants/externalRoutes';
import { IRouteParams } from '../../../../../routes/constants/routesConstants';
import { stringFormat } from '../../../../../utils/stringFormat';
import { TableFooterNameType } from '../../../../Table/types/tableTypes';
import {
    IUseTableFooterButtons,
    TTableButtonsGetTranslation,
    TUseTableFooterButtonsOnboarding,
    TUseTableFooterButtonsUrl,
} from '../useTableFooterButtons';

const useTableFooterButtonLimit = (
    getTranslation: TTableButtonsGetTranslation,
    tableFooterName: TableFooterNameType,
): IUseTableFooterButtons => {

    const { clientId } = useParams<IRouteParams>();

    return {
        className: 'table-footer__link link-limit',
        dataName: 'limit',
        icon: icons.infinityIcon,
        id: AccessComponentKeyEnum.FooterButtonDcruleChange,
        ...mapTableFooterNameToOnboarding[tableFooterName],
        ...getTranslation(AccessComponentKeyEnum.FooterButtonDcruleChange),

        onClick: useCallback(() => {
            const urlConfig = mapTableFooterNameToUrl[tableFooterName];
            if (!urlConfig) return;

            openExternalRoute(stringFormat(urlConfig.external, clientId));
        }, [tableFooterName, clientId]),
    };
};

const mapTableFooterNameToUrl: Partial<TUseTableFooterButtonsUrl> = {
    [TableFooterNameType.subscriberId]: {
        url: '',
        external: ExternalRoutePath.mobileDcRulesId,
    },
    [TableFooterNameType.subscriberMobile]: {
        url: '',
        external: ExternalRoutePath.mobileDcRules,
    },
};

const mapTableFooterNameToOnboarding: TUseTableFooterButtonsOnboarding = {
    [TableFooterNameType.subscriberMobile]: {
        onboarding: EOnboardingComponentsId.subscriberTableFooterButtonLimit,
    },
};

export default useTableFooterButtonLimit;
